"use client";

import * as React from "react";
import { ChartBlock, LiquidityPie } from "@/components";
import { useBidAsk } from "@/hooks/use-liquidity";
import { LIQUIDITY_CHARTS } from "@/constants";

export function BidAndAsk() {
  const { data, isLoading } = useBidAsk();
  const chartData = Array.isArray(data) ? data : [];

  return (
    <ChartBlock
      isSmall
      isRounded
      title="Bid / Ask Depth"
      isLoading={isLoading}
      className="overflow-visible"
      watermark={false}
    >
      <LiquidityPie
        data={chartData}
        colors={LIQUIDITY_CHARTS.BID_AND_ASK}
        isLoading={isLoading}
      />
    </ChartBlock>
  );
}
